
import $ from 'jquery';

var thelang = document.getElementsByTagName('html')[0].getAttribute('lang');

class piwigo{
    constructor(){
       // this.addSearchHTML();
        this.showTags = $("#piwigotags"); 
        this.showPhotos = $("#piwigophotos"); 

        this.language = document.getElementsByTagName('html')[0].getAttribute('lang');
        this.events();
        //this.getPiwiTags.bind(this);
    }

  
    // Events
    events() {
      this.piwigoTags();        
      this.piwigoPhotos();          
        //$(document).on("keydown", this.keyPressed.bind(this));
        
    }


    piwigoTags() {
      //this.searchResults.html("ok");  
      
      if (this.language == "el") {
          $.getJSON('https://pics.kamilari.org.gr/ws.php?format=json&method=pwg.tags.getList', tagresult => {            
              this.showTags.html(`<h2 class="search-ovelay__section-title">Αποτελέσματα</h2>                
                  ${tagresult.length ? `<div class="tags-results-list min-list">` : '' }                                
                  ${tagresult.result.tags.map(tag => `
                      ${tag.name.search(/[[]/) >1 ? `
                      <h2>${tag.name.substring(tag.name.search(/[[]/) + 1,tag.name.search(/[\]]/))}</h2>
                      <div class="tags-results-list__tag">                          
                          <div class='tags-results-list__title'><a target='_blank' href="${tag.url}">${tag.id} - ${tag.name}</a></div>
                          <div class='tags-results-list__foreis'>
                           Αριθμός φωτογραφιών ${tag.counter}
                          </div>
                      </div>
                      ` : '' }                                
                      
                  `).join('')}                                    
                  ${tagresult.length ? '</div>' : '' }
              `);
          });           
      } else {
          $.getJSON('/wp-json/uoc/v1/mscs?language=el&search=' + $("#search-term").val(), mscs => {            
              this.searchResults.html(`
                  <h2 class="search-ovelay__section-title">Results<h2>                
                  ${mscs.length ? `<ul class="mscs-results-list  min-list">` : 'No results' }                                
                  ${mscs.map(msc => `<li class="mscs-results-list__msc">
                      <a href="${msc.url}">${msc.title}</a></li>
                  `).join('')}                                    
                  ${mscs.length ? '</ul>' : '' }
              `);
          });
      }        
  }

  piwigoPhotos() {
    //this.searchResults.html("ok");  
    var thetagid=this.showPhotos.data('tagid');   
        $.getJSON('https://pics.kamilari.org.gr/ws.php?format=json&method=pwg.tags.getImages&tag_id=' + thetagid, tagresult => {            
            this.showPhotos.html(`<h3 class="search-ovelay__section-title">Φωτογραφίες αρχειοθήκης</h3>                
                ${tagresult.length ? `<div class="images-results-grid">` : '' }                                
                ${tagresult.result.images.map(image => `
                        <div class='images-results-grid__image'><a target='_blank' href="${image.page_url}"><img src='${image.derivatives.square.url}' /></a></div>
                `).join('')}                                    
                ${tagresult.length ? '</div>' : '' }
            `);
        });           
  }

  
  /*  
   // https://mscs.uoc.gr/wp-json/uoc/v1/mscs?search=
    getResults() {
        
        //this.searchResults.html("ok");        
        if (this.language == "el") {
            $.getJSON(uocmscs.root_url + '/wp-json/uoc/v1/mscs?language=el&search=' + $("#search-term").val(), mscs => {            
                this.searchResults.html(`<h2 class="search-ovelay__section-title">Αποτελέσματα<h2>                
                    ${mscs.length ? `<div class="mscs-results-list min-list">` : 'Δεν βρέθηκαν αποτελέσματα' }                                
                    ${mscs.map(msc => `
                        <div class="mscs-results-list__msc">
                            <div class='mscs-results-list__img-container'><img class='mscs-results-list__img' src='${msc.mscThumbUrl}' /></div>
                            <div class='mscs-results-list__title'><a href="${msc.url}">${msc.title}</a></div>
                            <div class='mscs-results-list__foreis'>
                                ${msc.organizingBodies.map(bd => `<a target='_blank' href='${bd.organizerWebsite}'>${bd.foreasThumbUrl ? `<img src='${bd.foreasThumbUrl}' />` : ''} ${bd.organizerName}</a>`).join(', ')}
                            </div>
                        </div>
                    `).join('')}                                    
                    ${mscs.length ? '</div>' : '' }
                `);
            });           
        } else {
            $.getJSON(uocmscs.root_url + '/wp-json/uoc/v1/mscs?language=el&search=' + $("#search-term").val(), mscs => {            
                this.searchResults.html(`
                    <h2 class="search-ovelay__section-title">Results<h2>                
                    ${mscs.length ? `<ul class="mscs-results-list  min-list">` : 'No results' }                                
                    ${mscs.map(msc => `<li class="mscs-results-list__msc">
                        <a href="${msc.url}">${msc.title}</a></li>
                    `).join('')}                                    
                    ${mscs.length ? '</ul>' : '' }
                `);
            });
        }        
    }
*/
 
  
}
export default piwigo;